<template>
    <span class="assignment-author">
        {{ label }}:
        <EmployeeLink v-if="userId" :user-id="userId" :fallback="name || fallback" compact open-in-panel />
        <span v-else>{{ name || fallback }}</span>
    </span>
</template>

<script>
import EmployeeLink from './EmployeeLink.vue';
export default {
    name: 'AssignmentAuthor',
    components: {EmployeeLink},
    props: {
        name: {type: String, default: null},
        userId: {type: [Number, String], default: null},
        label: {type: String, default: 'Назначил'},
        fallback: {type: String, default: 'автор не указан'}
    }
};
</script>

<style scoped>
.assignment-author { font-weight: 400; }
</style>
